import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {PagesFeed} from '@bepure/tarkin';

interface Item {
    image_url: string;
    link_url: string;
    text: string;
}

export interface Props {
    title: string;
    items: Item[];
    parentClass?: string;
}

const PageFeed = () => {
    const elements = document.getElementsByClassName('obiwan-page-feed');
    Array.from(elements).forEach(element => {
        const htmlElement = (element as HTMLElement);
        const title = htmlElement.dataset.title || '';
        const jsonObj: {'items': Item[]} = htmlElement.dataset.items ? JSON.parse(htmlElement.dataset.items) : [];
        const items = jsonObj.items.filter(item => item.image_url && item.link_url && item.text);
        const component = (
            <div className="react-page-feed">
                <PagesFeed
                    title={title}
                    items={items}
                    parentClass={'react-page-feed'}
                />
            </div>
        );
        ReactDOM.render(component, htmlElement);
    });
};
export default PageFeed;
